import { brandColor } from 'config/brandColor';

export const  BookingReportOptions = {
    responsive: true,
    maintainAspectRatio: false,
    
    plugins: {
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        xAxes: [{
          barThickness: 3,  // number (pixels) or 'flex'
          maxBarThickness: 5, // number (pixels)
          barPercentage: 0.4
      }]
      },
      
      legend: {
        display: false
      },
      title: {
        display: true,
        // text: 'Booking Reports',
        align: 'start',
        font: {
          size: "18px", 
          weight: 800,
        },
        padding:{
          bottom:20
        },
        color: '#282828',
      },
    }  };

const labels = ['Yesterday', 'Today', '06 Sept', '07 Sept', '08 Sept', '09 Sept', '10 Sept'];

export const BookingReport = () => ({
  labels,
  datasets: [
    {
      label: 'Ride',
      data: [70, 30, 100, 38, 62, 62, 100],
      backgroundColor: brandColor('accent', '#FFA726'),
      // barThickness: 50
      barPercentage: 0.35
    }
  ],
});



export const BookingStatus = {
  labels: ['Completed', 'Cancelled', 'Pending'],
  datasets: [
    {
      label:'Count',
      data: [ 1000, 400, 120  ],
      backgroundColor: ["#34D09D", '#FF7E7E', '#969696', ],
    },
  ],
};
export const BookingStatusOptions = {
  cutout: "70%",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 30,
        boxWidth: 20, 
        font: {
          size: 14, 
          weight: 'normal',
        },
      },
      padding:{
        top:50
      },
    },
    title: {
      display: true,
      // text: 'Booking Status',
      align: 'start',
      font: {
        size: 16, 
        weight: 600,
      },
      padding:{
        bottom:50
      },
      color: '#282828',
    },
  },
}


export const RevenueReport = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    xAxes: [{
      barThickness: 3,  // number (pixels) or 'flex'
      maxBarThickness: 5, // number (pixels)
      barPercentage: 0.4
  }]
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: true,
      // text: 'Revenue Reports',
      align: 'start',
      font: {
        size: 16, 
        weight: 600,
      },
      padding:{
        bottom:30
      },
      color: '#282828',
    },
  },
};


const revenueLabels = ['Yesterday', 'Today', '06 Sept', '07 Sept', '08 Sept', '09 Sept', '10 Sept', '11 Sept', '12 Sept', '13 Sept', '14 Sept', '15 Sept', '16 Sept'];

export const revenueBar = () => ({
  labels : revenueLabels,
  datasets: [
    {
      label: 'Revenue Reports',
      data: [150, 50, 200, 80, 100 , 100, 200, 60, 100, 100, 130, 30, 150],
      backgroundColor: brandColor('accent', '#FFA726'),
      // barThickness: 50
      barPercentage: 0.5
    }
  ],
});


